import { apiGetBlob } from "./http";

/** 运营端：导出活动会员报名 Excel（有关联协会时按协会分 Sheet） */
export async function downloadActivityMemberRegistrationsExcel(
  tenantLegacyId: string,
  activityLegacyId: string,
): Promise<Blob> {
  return apiGetBlob(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/activities/${encodeURIComponent(activityLegacyId)}/registrations/export`,
  );
}
